import module from './settings.module';

module.controller('SettingsController', [
  'AppService',
  'SettingsService',
  function (AppService, SettingsService) {
    var ctrl = this;

    AppService.pageTitle = 'Settings';

    this.msg = `You can tweak all your settings here`;
    SettingsService.settings.then(function (data) {
      ctrl.settings = data;
    });
  },
]);
